module.exports = __webpack_public_path__ + "img/google-pay.efb75d36.svg";